<app-back-button/>
<div class="page-header">
    <div class="left-area">
        <span class="title">Profissionais</span>
        <span class="sub-title">Consulte os profissionais nacionais do sector</span>
    </div>
    <div class="indicator" *ngIf="profissionaisCount">
        <div class="indicator">
            <div class="icon">
                <img src="icons/user-minus-01.svg" alt="Country Icon" />
            </div>
            <div class="text-bg">
                <span>{{profissionaisCount}} Profissionais</span>
            </div>
        </div>
    </div>
</div>

<app-lista-profissionais mode="filter" />
